import axios from "axios";

const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } });

export async function carregarLotes() {
  const { data } = await axios.get("/api/purchases/grouped", auth());
  return data || [];
}

// Todos os ingredientes + quais podem ser comprados (receita é produção interna; arquivado não se compra).
export async function carregarIngredientes() {
  const { data } = await axios.get("/api/ingredients", auth());
  const todos = data || [];
  let receitas = new Set();
  try {
    const { data: produtos } = await axios.get("/api/products", auth());
    const porNome = new Map(todos.map((i) => [(i.name || "").trim().toLowerCase(), i.id]));
    receitas = new Set((produtos || []).filter((p) => p?.product_type === "receita")
      .map((p) => p.linked_ingredient_id || porNome.get((p.name || "").trim().toLowerCase())).filter(Boolean));
  } catch {
    // sem produtos: vale só o is_recipe
  }
  const compraveis = todos.filter((i) => !i.is_recipe && !receitas.has(i.id) && i.is_active !== false);
  return { todos, compraveis };
}

export async function salvarCompra(loteId, payload) {
  if (loteId) return axios.put(`/api/purchases/batch/${loteId}`, payload, auth());
  return axios.post("/api/purchases/batch", payload, auth());
}
